(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = (window.DD && window.DD.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var noDec = String(Math.round(cents / 100));
    var withCommas = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas(noDec))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas(v.split('.')[0]).replace(/,/g, '.') + ',' + v.split('.')[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas(v.split('.')[0]) + '.' + v.split('.')[1]);
  }

  /* ---------- toast + cart count ---------- */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 3600);
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    evt.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'adding…'; }
    fetch(window.DD.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'could not add to bag');
        showToast('added to your bag ♥︎ <a href="' + window.DD.routes.cart_url + '">view bag</a>');
        refreshCount();
      })
      .catch(function (err) { showToast(String(err.message || err)); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; } });
  });

  /* ---------- variant pickers ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('script[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-button]');
    var btnLabel = root.querySelector('[data-add-label]');
    var updateUrl = root.hasAttribute('data-update-url');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('fieldset[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      root.querySelectorAll('fieldset[data-option]').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update(initial) {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        if (btn) btn.setAttribute('disabled', '');
        if (btnLabel) btnLabel.textContent = 'unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') + formatMoney(v.price);
      }
      if (btn) {
        if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', '');
      }
      if (btnLabel) btnLabel.textContent = v.available ? (btnLabel.getAttribute('data-default') || 'add to bag') : 'sold out';
      if (v.featured_media && !window.__ddFromGallery && !(initial && !/[?&]variant=/.test(window.location.search))) {
        var scope = root.closest('.product, .solo') || document;
        var thumb = scope.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (thumb && thumb.getAttribute('aria-current') !== 'true') { thumb.__fromPicker = true; thumb.click(); }
      }
      if (updateUrl && !initial && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) {
      var fs = e.target.closest('fieldset[data-option]');
      if (!fs) return;
      /* if this combo doesn't exist (e.g. a color that's sold out in this size),
         jump the other options to the closest combo that's in stock */
      var opts = selected();
      if (!findVariant(opts) || !findVariant(opts).available) {
        var idx = Array.prototype.indexOf.call(root.querySelectorAll('fieldset[data-option]'), fs);
        var alt = product.variants.find(function (v) { return v.available && v.options[idx] === opts[idx]; });
        if (alt) {
          root.querySelectorAll('fieldset[data-option]').forEach(function (f, i) {
            f.querySelectorAll('input').forEach(function (inp) { if (inp.value === alt.options[i]) inp.checked = true; });
          });
        }
      }
      update(false);
    });
    update(true);
  });

  /* ---------- gallery: thumbs, arrows, swipe; picking a photo picks its color ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));
    if (!main || !thumbs.length) return;
    var form = (g.closest('.product, .solo') || document).querySelector('[data-product-form]');

    function current() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    var token = 0;
    function swap(b) {
      main.srcset = b.getAttribute('data-srcset') || '';
      main.src = b.getAttribute('data-src');
      main.alt = b.getAttribute('data-alt') || '';
    }
    function show(b, dir, fromPicker) {
      var my = ++token;
      var box = main.parentElement;
      box.querySelectorAll('.gallery__incoming').forEach(function (x) { x.remove(); });
      if (main.getAnimations) main.getAnimations().forEach(function (x) { x.cancel(); });
      if (!dir || !main.animate || document.body.classList.contains('motion-off')) {
        swap(b);
      } else {
        /* load the new photo first, then slide it in over the old one so there's never a jump */
        var inc = new Image();
        inc.className = 'gallery__incoming';
        inc.alt = '';
        if (main.getAttribute('sizes')) inc.sizes = main.getAttribute('sizes');
        if (b.getAttribute('data-srcset')) inc.srcset = b.getAttribute('data-srcset');
        inc.src = b.getAttribute('data-src');
        var go = function () {
          if (my !== token) return;
          box.appendChild(inc);
          var opts = { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' };
          main.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (-35 * dir) + '%)', opacity: 0 }], opts);
          inc.animate([{ transform: 'translateX(' + (100 * dir) + '%)' }, { transform: 'translateX(0)' }], opts).onfinish = function () {
            if (my !== token) return;
            swap(b);
            var done = function () { if (inc.parentNode) inc.remove(); };
            if (main.decode) main.decode().then(done, done); else setTimeout(done, 50);
          };
        };
        (inc.decode ? inc.decode() : Promise.resolve()).then(go, go);
      }
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
      if (b.scrollIntoView && b.parentElement.parentElement.scrollWidth > b.parentElement.parentElement.clientWidth) {
        b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      /* select the matching color in the picker */
      var color = b.getAttribute('data-color');
      if (!fromPicker && color && form) {
        var inputs = form.querySelectorAll('fieldset[data-option] input[type=radio]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === color && !inputs[i].checked) {
            inputs[i].checked = true;
            window.__ddFromGallery = true;
            inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
            window.__ddFromGallery = false;
            break;
          }
        }
      }
    }
    var warm = function () { thumbs.forEach(function (t) { var i = new Image(); if (main.getAttribute('sizes')) i.sizes = main.getAttribute('sizes'); if (t.getAttribute('data-srcset')) i.srcset = t.getAttribute('data-srcset'); i.src = t.getAttribute('data-src'); }); };
    if (document.readyState === 'complete') setTimeout(warm, 600); else window.addEventListener('load', function () { setTimeout(warm, 600); });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function (e) {
        var from = current(), to = thumbs.indexOf(b);
        show(b, to === from ? 0 : (to > from ? 1 : -1), !!e.__fromPicker || b.__fromPicker);
        b.__fromPicker = false;
      });
    });
    function step(d) {
      var i = (current() + d + thumbs.length) % thumbs.length;
      show(thumbs[i], d, false);
    }
    g.querySelectorAll('[data-gallery-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { step(parseInt(btn.getAttribute('data-gallery-step'), 10)); });
    });
    /* swipe on phones */
    var sx = null, sy = null;
    main.parentElement.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    main.parentElement.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var n = parseInt(input.value, 10) || 1;
    n = b.getAttribute('data-qty') === 'up' ? n + 1 : Math.max(parseInt(input.min || '1', 10), n - 1);
    input.value = n;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart page: change quantities and remove items in place (no page reload) ---------- */
  var cartForm = document.querySelector('form[data-cart-form]');
  if (cartForm) {
    var motion = function () { return !reduce && !document.body.classList.contains('motion-off'); };
    var applyCart = function (cart) {
      var sub = cartForm.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      cartForm.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var line = cart.items.find(function (it) { return it.key === row.getAttribute('data-key'); });
        if (line) {
          var p = row.querySelector('[data-line-price]');
          if (p) p.textContent = formatMoney(line.final_line_price);
          var q = row.querySelector('input[name="updates[]"]');
          if (q && document.activeElement !== q) q.value = line.quantity;
        }
      });
      if (!cart.item_count) {
        var empty = document.querySelector('[data-cart-empty]');
        var swap = function () { cartForm.remove(); if (empty) { empty.hidden = false; if (motion() && empty.animate) empty.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: 'ease-out' }); } };
        if (motion() && cartForm.animate) cartForm.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250 }).onfinish = swap; else swap();
      }
    };
    var change = function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    };
    /* the item pops (a quick swell), then shrinks away and the rows below slide up */
    var popOut = function (row, done) {
      if (!motion() || !row.animate) { row.remove(); done(); return; }
      row.style.overflow = 'hidden';
      var h = row.offsetHeight;
      row.animate([
        { transform: 'scale(1)', opacity: 1 },
        { transform: 'scale(1.04)', opacity: 1, offset: .25 },
        { transform: 'scale(.6)', opacity: 0 }
      ], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).onfinish = function () {
        row.animate([
          { height: h + 'px', paddingTop: getComputedStyle(row).paddingTop, paddingBottom: getComputedStyle(row).paddingBottom, borderBottomWidth: getComputedStyle(row).borderBottomWidth },
          { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px' }
        ], { duration: 260, easing: 'ease-in-out', fill: 'forwards' }).onfinish = function () { row.remove(); done(); };
      };
    };
    var removeRow = function (row) {
      if (row._removing) return;
      row._removing = true;
      row.style.pointerEvents = 'none';
      var req = change(row.getAttribute('data-key'), 0);
      popOut(row, function () {
        req.then(applyCart).catch(function () { window.location.reload(); });
      });
    };
    cartForm.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      removeRow(rm.closest('[data-cart-item]'));
    });
    cartForm.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('input[name="updates[]"]')) return;
      var row = input.closest('[data-cart-item]');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      if (qty === 0) { removeRow(row); return; }
      clearTimeout(row._t);
      row._t = setTimeout(function () {
        change(row.getAttribute('data-key'), qty).then(applyCart).catch(function () { window.location.reload(); });
      }, 350);
    });
  }
})();

/* copy-to-clipboard buttons */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-copy]');
  if (!b) return;
  var text = b.getAttribute('data-copy');
  var done = function () { var t = b.textContent; b.textContent = 'copied ♥︎'; setTimeout(function () { b.textContent = t; }, 1800); };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(done, function () { window.prompt('Copy this address:', text); });
  } else { window.prompt('Copy this address:', text); }
});

/* logo: grow + full star spin on tap; on the home page it never reloads, it spins and floats to the top */
(function () {
  var logo = document.querySelector('.site-header .logo') || document.querySelector('.logo');
  if (!logo) return;
  var star = logo.querySelector('svg');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOff = function () { return reduce || document.body.classList.contains('motion-off'); };
  var href = logo.getAttribute('href') || '/';
  var onHome = document.body.classList.contains('template-index') ||
    new URL(href, location.href).pathname === location.pathname;
  var lastSpin = 0, lastPointer = '';

  function spin() {
    if (motionOff()) return;
    var now = Date.now();
    if (now - lastSpin < 250) return;          /* touchstart + click fire together: spin once */
    lastSpin = now;
    var opts = { duration: 800, easing: 'cubic-bezier(.45,0,.2,1)' };
    if (logo.animate) {
      [logo, star].forEach(function (el) { if (el && el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); });
      logo.animate([{ transform: 'scale(1) rotate(0deg)' }, { transform: 'scale(1.12) rotate(-3deg)', offset: .45 }, { transform: 'scale(1) rotate(0deg)' }], opts);
      if (star) star.animate([{ transform: 'rotate(0deg) scale(1)' }, { transform: 'rotate(200deg) scale(1.3)', offset: .5 }, { transform: 'rotate(360deg) scale(1)' }], opts);
      var sp = star && star.querySelector('path');
      if (sp && sp.animate) {
        var cs = getComputedStyle(document.documentElement);
        var pink = cs.getPropertyValue('--dd-accent').trim() || '#FF8FCB', yel = cs.getPropertyValue('--dd-yellow').trim() || '#FFE46B';
        sp.animate([{ fill: pink }, { fill: yel, offset: .35 }, { fill: yel, offset: .75 }, { fill: pink }], opts);
      }
    } else {
      logo.classList.remove('is-spinning'); void logo.offsetWidth; logo.classList.add('is-spinning');
    }
  }

  logo.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType || '';
    if (onHome && lastPointer !== 'mouse') spin();
  });
  logo.addEventListener('touchstart', function () {
    lastPointer = 'touch';
    if (onHome) spin();
  }, { passive: true });

  logo.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    var isTouch = lastPointer === 'touch' || lastPointer === 'pen' ||
      (!lastPointer && window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    lastPointer = '';
    if (onHome) {
      e.preventDefault();
      spin();
      window.scrollTo({ top: 0, behavior: motionOff() ? 'auto' : 'smooth' });
      return;
    }
    if (motionOff() || !isTouch) return;
    e.preventDefault();
    spin();
    setTimeout(function () { window.location.href = href; }, 800);
  });
})();

/* in-page links (meet ducky, shop the drop) slide their section up with a soft blur, centered;
   links to other pages fade the page out, and every page slides in (CSS) when it loads */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var off = function () { return reduce || document.body.classList.contains('motion-off'); };
  var main = document.getElementById('MainContent');

  function hashTarget(hash) {
    if (!hash || hash === '#' || hash === '#MainContent') return null;
    try { return document.querySelector(hash); } catch (e) { return null; }
  }
  function centerY(el) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight, top = r.top + window.pageYOffset, dest;
    if (r.height < vh * 0.92) dest = top - (vh - r.height) / 2;
    else {
      var h = el.querySelector('h2, h1');
      var hTop = h ? h.getBoundingClientRect().top + window.pageYOffset : top;
      dest = Math.max(top - 16, hTop - vh * 0.6);
    }
    return Math.max(0, Math.min(dest, document.documentElement.scrollHeight - vh));
  }
  function slideTo(el) {
    el.querySelectorAll('.reveal').forEach(function (n) { n.classList.add('is-visible'); });
    var dest = centerY(el);
    if (off() || !el.animate) { window.scrollTo(0, dest); return; }
    var vh = window.innerHeight;
    var start = dest - Math.min(220, vh * 0.28);          /* short glide down the page... */
    if (start < 0) start = 0;
    window.scrollTo(0, start);
    var t0 = null, dur = 900;
    var ease = function (t) { return 1 - Math.pow(1 - t, 4); };
    requestAnimationFrame(function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      window.scrollTo(0, start + (dest - start) * ease(p));
      if (p < 1) requestAnimationFrame(step);
    });
    var prevPos = el.style.position, prevZ = el.style.zIndex;
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.style.zIndex = '2';
    var a = el.animate([                                    /* ...while the section rises up from below */
      { transform: 'translateY(' + Math.round(vh * 0.45) + 'px)', filter: 'blur(14px)', opacity: 0 },
      { transform: 'translateY(' + Math.round(vh * 0.08) + 'px)', filter: 'blur(4px)', opacity: 1, offset: .55 },
      { transform: 'translateY(0)', filter: 'blur(0)', opacity: 1 }
    ], { duration: 950, easing: 'cubic-bezier(.2,.8,.2,1)' });
    a.onfinish = a.oncancel = function () { el.style.position = prevPos; el.style.zIndex = prevZ; };
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var raw = a.getAttribute('href') || '';
    var u; try { u = new URL(raw, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    var samePage = u.pathname === location.pathname && u.search === location.search;
    if (samePage && u.hash) {
      var el = hashTarget(u.hash);
      if (!el) return;
      e.preventDefault();
      slideTo(el);
      if (history.replaceState) history.replaceState(null, '', '#' + el.id);
      return;
    }
    if (samePage || raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) return;
    /* another page on the site: quick fade-out, then go */
    if (off() || !main || !main.animate) return;
    e.preventDefault();
    main.animate([{ opacity: 1, transform: 'none', filter: 'blur(0)' },
                  { opacity: 0, transform: 'translateY(-24px)', filter: 'blur(6px)' }],
                 { duration: 220, easing: 'ease-in', fill: 'forwards' });
    setTimeout(function () { window.location.href = u.href; }, 200);
  });

  /* arriving with a #section in the address (e.g. from another page) */
  if (location.hash) {
    var target = hashTarget(location.hash);
    if (target && target.tagName !== 'SECTION') target = null;
    if (target) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.addEventListener('load', function () { setTimeout(function () { slideTo(target); }, 60); });
    }
  }
  /* coming back with the browser's back button: undo the fade-out */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted && main && main.getAnimations) main.getAnimations().forEach(function (x) { x.cancel(); });
  });
})();

/* after sending the contact form (or the email signup) the page reloads; keep the
   "thanks!" message centered on screen instead of letting the browser jump around */
(function () {
  var notice = document.querySelector('form .notice[role="status"]');
  if (!notice) return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  var userMoved = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, function () { userMoved = true; }, { passive: true, once: true });
  });
  function pageTop(el) { var y = 0; while (el) { y += el.offsetTop; el = el.offsetParent; } return y; }
  function center() {
    if (userMoved) return;
    var y = pageTop(notice) - Math.max(80, (window.innerHeight - notice.offsetHeight) / 2 - 60);
    window.scrollTo(0, Math.max(0, y));
  }
  /* drop the #ContactForm / #Newsletter from the address so the browser stops re-jumping to it */
  if (location.hash && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
  center();
  requestAnimationFrame(center);
  window.addEventListener('load', function () { center(); setTimeout(center, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(center);
})();
